<template>
  <div class="goodsInventoryQuotation">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="container">
          <div class="list-item">
            {{ $t.goodsInventory.qNumber }}：{{ item.PurchaseQuotationNumber }}
          </div>
          <div class="list-item">
            {{ $t.goodsInventory.supplierNumber }}：{{ item.CustomerName }}
          </div>
          <div class="list-item">
            {{ $t.goodsInventory.supplierName }}：{{ item.CustomerName }}
          </div>
          <div class="list-item">
            {{ $t.goodsInventory.preTaxPurchasePrice }}：{{ item.PreTaxPurchasePrice }}
          </div>
          <div class="list-item">
            {{ $t.goodsInventory.invoicingTaxRate }}：{{ item.InvoicingTaxRate }}
          </div>
          <div class="list-item">
            {{ $t.goodsInventory.invoiceType }}：
            <span v-if="item.InvoiceType == 1">{{ $t.goodsInventory.invoiceType1 }}</span>
            <span v-if="item.InvoiceType == 2">{{ $t.goodsInventory.invoiceType2 }}</span>
          </div>
          <div class="list-item">
            {{ $t.goodsInventory.afterTaxPurchasePrice }}：{{
              item.AfterTaxPurchasePrice
            }}
          </div>
          <div class="list-item">
            {{ $t.goodsInventory.invoiceIncludingTaxRate }}：{{
              item.InvoiceIncludingTaxRate
            }}
          </div>
          <div class="list-item">
            {{ $t.goodsInventory.productTaxAmount }}：{{ item.ProductTaxAmount }}
          </div>
          <div class="list-item">
            {{ $t.goodsInventory.productState }}：
            <span v-if="item.QuoteState == 1">{{ $t.goodsInventory.normal }}</span>
            <span v-if="item.QuoteState == -1">{{ $t.goodsInventory.disable }}</span>
          </div>
          <div class="list-item">
            {{ $t.goodsInventory.quoteDate }}：{{ item.CreateTime }}
          </div>
          <div class="buttons">
            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              @click="gotoDetail(item.PQId)"
              >{{ $t.meta.editButton }}</van-button
            >

            <van-button
              :class="item.QuoteState == '1' ? 'default-btn' : 'search-btn'"
              size="small"
              type="primary"
              @click="editQuoteStateByPQId(item)"
            >
              <span v-if="item.QuoteState == '1'">{{ $t.meta.disable }}</span>
              <span v-else>{{ $t.meta.enable }}</span></van-button
            >

            <van-button
              class="danger-btn"
              size="small"
              type="primary"
              @click="dialogDeleteShow(item.PQId)"
              >{{ $t.meta.delete }}</van-button
            >
          </div>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.goodsInventory.sort }}</div>
        <van-radio-group v-model="orderBy" direction="horizontal">
          <van-radio :name="0">{{ $t.goodsInventory.qOrderBy1 }}</van-radio>
          <van-radio :name="1">{{ $t.goodsInventory.qOrderBy2 }}</van-radio>
          <van-radio :name="2">{{ $t.goodsInventory.qOrderBy3 }}</van-radio>
          <van-radio :name="3">{{ $t.goodsInventory.qOrderBy4 }}</van-radio>
          <van-radio :name="4">{{ $t.goodsInventory.qOrderBy5 }}</van-radio>
          <van-radio :name="5">{{ $t.goodsInventory.qOrderBy6 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.goodsInventory.productState }}</div>
        <van-radio-group v-model="productState" direction="horizontal">
          <van-radio :name="1">{{ $t.goodsInventory.normal }}</van-radio>
          <van-radio :name="-1">{{ $t.goodsInventory.disable }}</van-radio>
        </van-radio-group>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteProcurementProductQuotation"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.meta.deleteConfirm }}
      </div>
    </van-dialog>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.goodsInventory.createQuotation
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Image,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup)
  .use(Image);

export default {
  name: "goodsInventoryQuotation",
  data() {
    return {
      PId: "",
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.goodsInventory.customerNumber,
          value: 1,
        },
        {
          text: this.$t.goodsInventory.customerName,
          value: 2,
        },
      ],
      showFilter: false,
      productState: null,
      orderBy: 0,
      //删除订单
      showDeleteDialog: false,
      dialogDeleteId: null,
    };
  },
  created() {
    const { PId } = this.$route.query;
    this.PId = PId;
  },
  methods: {
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "goodsInventoryQuotationDetail",
        name: "goodsInventoryQuotationDetail",
        query: [
          {
            name: "PQId",
            value: id ? id : null,
          },
          {
            name: "PId",
            value: this.PId,
          },
        ],
      });
    },
    editQuoteStateByPQId(item) {
      this.$commonMethod.showLoading();
      var param = {
        PQId: item.PQId,
        QuoteState: Number(item.QuoteState == 1) ? -1 : 1,
      };
      this.$api.purchasingManagement
        .editQuoteStateByPQId(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    deleteProcurementProductQuotation() {
      this.$commonMethod.showLoading();
      var param = {
        PQId: this.dialogDeleteId,
      };
      this.$api.purchasingManagement
        .deleteProcurementProductQuotation(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.showDeleteDialog = false;
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.productState) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.productState = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        PId: this.PId,
        CustomerNumber: this.searchType == 1 ? this.searchText : "",
        CustomerName: this.searchType == 2 ? this.searchText : "",
        OrderBy: this.orderBy,
        ProductState: this.productState,
      };
      this.$api.purchasingManagement
        .getProcurementProductQuotationListByPage(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.goodsInventoryQuotation {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
